
import { mdiCheck, mdiInformation } from '@mdi/js'

export default {
  icons: { mdiCheck, mdiInformation },
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
